import styled from 'styled-components';

export const CommentsSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  max-width: 375px;

  gap: 16px;
  max-height: calc(100vh - 120px);
  padding: 20px 24px;
  align-items: flex-start;
  overflow-y: auto;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  background: ${({ theme }) => theme.colors.white};

  @media (max-width: ${({ theme }) => theme.mediaQueries.md}) {
    width: 100%;
    max-width: 100%;
  }
`;

export const CommentsSectionTitle = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;
